import { EventOptions, JQueryInput } from "./types";
import { manageButtonClick } from "./skyward.ui.buttonManager";
import { isDeferred } from "./skyward.base.extensions.promise";
export { getCallbackStore, getCallbackStoreFacadeCollection } from "./skyward.ui.callbackStore";

export type EventDictionary = { [key: string]: Function | EventOptions; };

interface Actions { [key: string]: { [key: string]: (Function | EventOptions); }; };

const actions: Actions = {};
const classNames =
{
    loadActionMarkerClass: "js-load-action",
    visibleActionMarkerClass: "js-visible-action"
};

export let applyLoadActionClass = function (element: JQueryInput)
{
    const loadActionSelector = "[data-load-action]";
    const origElement = $(element);
    const loadActionElements = origElement.find(loadActionSelector).addBack(loadActionSelector);
    loadActionElements.addClass(classNames.loadActionMarkerClass);
};

export function reapplyLoadActionClasses(element: JQuery<HTMLElement>)
{
    const data = element.data();
    if (data?.loadAction)
    {
        element.addClass(classNames.loadActionMarkerClass);
    }
    if (data?.visibleAction)
    {
        element.addClass(classNames.visibleActionMarkerClass);
    }
}

export let removeLoadActionClass = function (element: JQueryInput)
{
    const origElement = $(element);
    const loadActionElements = origElement.find(classNames.loadActionMarkerClass.dot()).addBack(classNames.loadActionMarkerClass.dot());
    loadActionElements.removeClass(classNames.loadActionMarkerClass);
};

export let clickEvent = manageButtonClick(function (this: HTMLElement, ...args: any[])
{
    const element = $(this).addIds();

    return callEventHandler(this, element.data("clickAction"), args);
});

export let getActionFunction = (actionKey: string) =>
{
    const [namespace, actionName] = actionKey.split('.');
    const action = actions?.[namespace]?.[actionName];
    if (action !== undefined)
    {
        return typeof action === "function" ? action : action.function;
    }
    return undefined;
};

/**
 * @description Run actions that should take place the first time an element becomes visible, defined using data-visible-action.
 * @param {JQuery<HTMLElement>} context The root element to process
 */
export let processVisibleActions = function (context: JQuery<HTMLElement>)
{
    processEvents(context, classNames.visibleActionMarkerClass, "visibleAction");
};

export function registerEvents(namespace: string, events: { [key: string]: Function | EventOptions; })
{
    actions[namespace] = $.extend(actions[namespace] || {}, events);
};

$(document.body)
    .on("click", "[data-click-action]", clickEvent)

    // Firefox assumes that if you shift click a link, you want to open it in a new tab.
    // Since our buttons are hrefs, Firefox will attempt to open a new tab.
    // Preventing default prevents this from happening.
    .on("click", "a.button:not(.js-button--link), a[href^='javascript:']", function (event)
    {
        event.preventDefault();
    });


function callEventHandler(element: JQueryInput, handlerNames: string, args: Array<any>): JQueryPromise<any>
{
    const deferred = $.Deferred();

    const qualifiedActions = handlerNames.split(';');
    for (let i = 0; i < qualifiedActions.length; i++)
    {
        const [namespace, actionName] = qualifiedActions[i].split('.');
        // We support loading a namespace without and action. This causes the namespace's dependencies to be loaded, but does not execute any action.
        // This us useful for loading a XRef Partial or XRef Script without having to call an event function.
        if (!actionName)
        {
            continue;
        }
        const action = actions?.[namespace]?.[actionName];
        if (action !== undefined)
        {
            const actionHandler = typeof action === "function" ? action : action.function;
            const returned = actionHandler.apply(element, args);
            if (isDeferred(returned)) 
            {
                return returned;
            }
        }
        else
        {
            console.warn(`No action ${qualifiedActions[i]}`);
        }
    }

    deferred.resolve();
    return deferred.promise();
};

function processEvents(context: JQuery<HTMLElement>, markerClass: string, dataName: string) 
{
    context.find(markerClass.dot()).addBack(markerClass.dot()).each(function ()
    {
        const element = $(this).addIds();
        element.removeClass(markerClass);
        callEventHandler(element, element.data(dataName), [element]);
    });
};

/**
 * For use by NotifyDOMLoad
 * @param element
 */
export let processLoadActions = function (this: JQuery<HTMLElement>, _selector: string)
{
    processEvents(this, classNames.loadActionMarkerClass, "loadAction");
};
